import { CurrentToken } from "app/models/user"
import { Action, Types } from "./authorization.actions"

export type AuthorizationState = {
  loading: boolean
  dispatched: boolean
  currentToken: CurrentToken | undefined
  authorized: boolean
  errors: {}
}

const initialState: AuthorizationState = {
  authorized: false,
  currentToken: undefined,
  errors: {},
  loading: false,
  dispatched: false,
}

export default (state = initialState, action: Action): AuthorizationState => {
  switch (action.type) {
    case Types.AUTHORIZE:
      return {
        ...state,
        authorized: false,
        loading: true,
        dispatched: false,
      }

    case Types.AUTHORIZE_SUCCESS:
      return {
        ...state,
        authorized: true,
        currentToken: action.payload.currentToken,
        errors: {},
        loading: false,
        dispatched: true,
      }

    case Types.AUTHORIZE_FAIL:
      return {
        ...state,
        authorized: false,
        errors: action.payload.errors,
        loading: false,
        dispatched: true,
      }

    default:
      return state
  }
}
